"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionsDiscovery = void 0;
const AccountingDiscovery_1 = require("./accounting/AccountingDiscovery");
const CallingDiscovery_1 = require("./calling/CallingDiscovery");
const CardsDiscovery_1 = require("./cards/CardsDiscovery");
const VideoconferencingDiscovery_1 = require("./videoconferencing/VideoconferencingDiscovery");
class ExtensionsDiscovery {
    constructor(config) {
        this.accounting = new AccountingDiscovery_1.AccountingDiscovery(config);
        this.calling = new CallingDiscovery_1.CallingDiscovery(config);
        this.cards = new CardsDiscovery_1.CardsDiscovery(config);
        this.videoconferencing = new VideoconferencingDiscovery_1.VideoconferencingDiscovery(config);
    }
}
exports.ExtensionsDiscovery = ExtensionsDiscovery;
//# sourceMappingURL=ExtensionsDiscovery.js.map